import { z } from 'zod'

export const EditPresetSchema = z.object({
	bodyPartId: z
		.string()
		.min(1, { message: 'Required' })
		.transform((elem) => parseInt(elem, 10)),
	injuryId: z
		.string()
		.min(1, { message: 'Required' })
		.transform((elem) => parseInt(elem, 10)),
	acutePhase: z.boolean(),
	medicalActs: z.array(
		z.object({
			quantity: z.number().min(1),
			medicalActId: z.string(),
		})
	),
	appointments: z.array(
		z.object({
			quantity: z.number().min(1),
			specialtyId: z.string(),
		})
	),
})
